import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    selector: String
  }

  trigger() {
    document.getElementById(this.selectorValue).innerHTML = ''
  }
}
